import {createSelector} from 'reselect';
import {RootState} from '../types/store';

export const selectGDPRComponent = createSelector(
  (state: RootState) => state.gdpr,
  gdpr => gdpr.gdpr
);
